<i18n>
{
	"en": {
		"title" : "Edit outbound EDI Setup",
		"bundleSupport": "EDI message bundle?",
		"setupDetails": "EDI Setup",
		"otherOptions": "Other options",
		"codelists": "Codelists"
	},
	"no":{
		"title" : "Rediger utgående EDI oppsett",
		"bundleSupport": "Bundling av edi meldinger?",
		"setupDetails": "EDI oppsett",
		"otherOptions": "Andre instillinger",
		"codelists": "Kodelister"
	}
}
</i18n>

<template>
	<div v-if="fetchedMetadata" class="details-grid">
		<div class="navigation">
			<t-tab-list :items="tabs" :selected.sync="selectedTab" sidebar>
				<template v-slot="slotProps">
					<t-tab :value="slotProps.item" :selected="slotProps.isSelected" :sidebar="slotProps.sidebar">
						{{$t(slotProps.item.key)}}
					</t-tab>
				</template>
			</t-tab-list>
		</div>
		<t-pane class="settings-content">
			<component
				:is="selectedTab.id"
				:ref="selectedTab.ref"
				:edisetup="outboundEdiSetting"
				:messageMetadata="metaData"
			/>
		</t-pane>
	</div>
</template>

<script>

import getEdipartMetadatas from '../requests/getEdipartMetadatas';
import SetupDetails from './outbound/SetupDetails.vue';
import OtherOptions from './outbound/OtherOptions.vue';
import Codelists from './common/ManageCodelists.vue';
export default {
	components: { SetupDetails, OtherOptions, Codelists },
	props: { outboundEdiSetting: Object, },
	data() {
		return {
			tabs: [
				{ id:'SetupDetails', key: 'setupDetails', ref: 'setupDetails', item: 'test' },
				{ id:'OtherOptions', key: 'otherOptions', ref: 'otherOptions' },
				{ id:'Codelists', key: 'codelists', ref: 'codelists' }
			],
			selectedTab: { id:'SetupDetails', key: 'setupDetails', ref: 'setupDetails' },
			bundleSupport: false,
			selectedOutboundMessageMetadata: null,
			metaData: null,
			fetchedMetadata: false,
		};
	},

	async mounted() {
		this.metaData = await getEdipartMetadatas();
		let messageTypeMetadata = this.metaData.outboundMessageMetadata.find(x => x.format === this.outboundEdiSetting.messageType);
		let supportedFormat = messageTypeMetadata.supportedMessageFormats.find(x => x.format === this.outboundEdiSetting.messageFormat);
		this.bundleSupport = supportedFormat.bundleSupport;
		this.fetchedMetadata = true;
	},
	methods:{
		onMessageMetadataChanged(metaDataObject) {
			let format = metaDataObject.supportedMessageFormats.find(x => x.format === this.outboundEdiSetting.messageFormat);
			this.bundleSupport = format.bundleSupport === true;
		},
		onBundleSupport(supportsBundling) {
			this.bundleSupport = supportsBundling;
		},
	}
};
</script>

<style lang="scss" scoped>


.details-grid{
	display: grid;
	grid-template-columns: 240px 1100px;
}
</style>